import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: string;
}

export default function Input({ label, helperText, error, className = '', id, ...props }: InputProps) {
  const inputId = id || label?.toLowerCase().replace(/\s/g, '-');
  return (
    <div>
      {label && <label htmlFor={inputId} className="form-label">{label}</label>}
      <input
        id={inputId}
        className={`form-input ${error ? 'border-red' : ''} ${className}`}
        style={error ? { borderColor: 'var(--red)' } : undefined}
        {...props}
      />
      {helperText && !error && <p className="form-helper">{helperText}</p>}
      {error && <p className="form-helper form-helper-error">{error}</p>}
    </div>
  );
}
